import theme from 'theme'
import { DeliveryInformation } from 'utils/calculateDeliveryDate'

export default function getDeliveryInfoColor(
  icon: DeliveryInformation['icon'] | undefined
): string {
  switch (icon) {
    case 'available':
      return theme.colors.accent.green
    case 'warning':
      return theme.colors.warning
    case 'notAvailable':
      return theme.colors.accent.blue
    default:
      return theme.colors.shade.b2
  }
}
